export default __webpack_public_path__ + "static/media/warning--dual-lanes-turn-left-or-right--g1.920cce95.png";